import React, { useState, forwardRef, useImperativeHandle } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Autocomplete from '@material-ui/lab/Autocomplete';

const CssSelect = withStyles({
  root: {
    width: "100%",
    color: '#fff',
    fontSize: '1rem',
    fontFamily: 'Cera CY',
    fontWeight: 400,
    background: 'none',

    'label + &': {
      color: '#fff',
    },

    'input + &': {
      color: '#fff'
    },

    '&:before': {
      borderBottom: '1px solid #fff'
    },

    "& label.Mui-focused": {
      color: "#8987A2"
    },

    "& .MuiFilledInput-root": {
      background: "#F6F6FB",
      borderRadius: "4px",
      color: '#3C3C56',
    },

    "& .MuiSelect-icon": {

      color: '#3C3C56',
    }
  },

  select: {
    background: 'none'
  },

  filled: {
    background: 'none',
    borderColor: '#fff'
  },

  nativeInput: {
    borderColor: '#fff'
  },

  icon: {
    color: '#fff'
  },

  '&:before': {
    borderBottom: '1px solid #fff'
  },
})(TextField);

const StyledTextField = withStyles({
  root: {
    color: '#8987A2',
    margin: 0,
    marginTop: 0,
    padding: 0,

    borderRadius: 24,
    input: {
      color: '#8987A2',
      marginTop: 0,
      padding: 0,
      paddingRight: 64

    },

    "& .MuiInputBase-root": {
      padding: '5px 16px',
      color: '#8987A2',
    }
    ,
    "& :before": {
      border: "none"
    },
    "& :after": {
      "& :hover": {
        border: "none"
      }
    },
    "&:hover": {
      border: "none"
    },
    "& :focus": {
      border: "none"
    },
    "& .MuiInput-underline:after": {
      border: "none"
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "none"
      },
      "&:hover fieldset": {
        border: "none"
      },
      "&.Mui-focused fieldset": {
        border: "none"
      }
    }
  }
})(TextField);

const StyledAutocomplete = withStyles((theme) => ({
  root: {
    position: 'relative',
    marginLeft: 0,
    width: '100%',
    minWidth: 296,
    color: '#8987A2',

    "& .MuiAutocomplete-popupIndicator": {
      color: "rgba(137, 135, 162, 1)"
    },

    "& .MuiAutocomplete-clearIndicatorDirty": {
      color: "rgba(137, 135, 162, 1)",
      display: 'none'
    },

    [theme.breakpoints.down(696)]: {
      minWidth: 96,
    }
  },
}))(Autocomplete);

function CustomizedInputs(props, ref) {
  const classes = useStyles();
  const [searchValue, _searchValue] = useState('');
  const [init, _init] = useState(true);
  if (searchValue === '' && props.value === undefined && props.defaultValue !== undefined && init) {
    _searchValue(props.defaultValue);
    _init(false);
  }
  useImperativeHandle(ref, () => ({
    clearValue: () => {
      _searchValue('');
    },
    getValue: () => {
      return searchValue
    },
    setValue : (val) => {
      _searchValue(val);
    }
  }));

  const callOnKeyDown = (event, val) => {
    if (event.key === 'Enter' && val !== "") {
      props.onKeyDown(val)
    }
  }

  const isControlled = props.filteredSearchFunc === undefined;
  return (
    <StyledAutocomplete
      style={{ marginLeft: !isControlled ? 26 : undefined, paddingRight: !isControlled ? 70 : 32 }}
      options={isControlled ? props.options || [] : props.filteredSearchFunc(props.options, searchValue).map(el => el.searchValue)}
      renderOption={(option, props) => {
        let optionValue = option;
        try{ 
          optionValue=typeof props.inputValue === 'string' && props.inputValue.length > 1 && props.inputValue !== '??' ? option.replace(new RegExp(props.inputValue, "gmi"), `<span style="color:black;">${props.inputValue}</span>`) :  option;
        } catch (e) {
          optionValue = option;
        }
        return (
          <li style={{ paddingTop: '4px', paddingBottom: '4px' }} {...props} dangerouslySetInnerHTML={{ __html: `<span style="color:#8987A2;font-weight:400;">${optionValue}</span>` }}></li>
        )
      }}
      classes={{ paper: classes.paper }}
      onInputChange={(e, val) => isControlled ? props.onChange(e, val) : _searchValue(val)}
      disableClearable
      freeSolo
      defaultValue={props.defaultValue}
      value={props.value}
      id={props.id}
      onFocus={props.onBlur}
      onBlur={props.onBlur}
      onChange={(e, val) => {console.log('csa-onChange', e.key,val); if (e.key === 'Enter') { e.preventDefault() ;props.onKeyDown(val); }; isControlled ? props.onChange(e, val) : _searchValue(val) }}
      inputValue={isControlled ? props.value : searchValue}
      label={props.label}
      renderInput={(params) => <StyledTextField {...params} id={props.inputId} /*needCheckOptionModal = {props.needCheckOptionModal}*/ onKeyDown={(e) => {console.log(props.needCheckOptionModal);if (props.needCheckOptionModal !== true || e.key !== 'Enter' || e.currentTarget.parentElement.getAttribute('aria-expanded') !== 'true' ) {callOnKeyDown(e, props.value || searchValue)} }} variant="outlined" placeholder={props.label} margin="normal" />}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: "16px",
    minWidth: 220
  },

  root: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    background: 'none',
  },

  inputRoot: {
    color: '#8987A2',
    float: 'right',
    [theme.breakpoints.down(1032)]: {
      backgroundColor: 'transparent',
      width: '100%',
      float: 'right',
      zIndex: 11
    },

    '&:focus': {
      zIndex: 4
    }
  },

  inputInput: {
    padding: theme.spacing(1, 2),
    paddingRight: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: 232,
    height: 32,
    [theme.breakpoints.down(1032)]: {
      width: 0,
      zIndex: 11,

      '&:focus': {
        width: 207,

        [theme.breakpoints.down('md')]: {
          width: '100%',
          zIndex: 4
        }
      },
    },
    color: '#8987A2'
  },

  search: {
    position: 'relative',
    borderRadius: 24,
    marginLeft: 0,
    marginRight: theme.spacing(1),
    width: 'auto',

    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },

    [theme.breakpoints.down(1032)]: {
      backgroundColor: 'transparent',
      width: '100%'
    }
  },
}));

export default forwardRef(CustomizedInputs)